export function stop (e: Event) {
  e.stopPropagation()
}

export function prevent (e: Event) {
  e.cancelable !== false && e.preventDefault()
}

export function stopAndPrevent (e: Event) {
  e.cancelable !== false && e.preventDefault()
  e.stopPropagation()
}
